module.exports = __webpack_public_path__ + "static/media/benefits-platinum.df2cd205.png";